function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

// TODO: Use components from @designi
var StyledDiv = styled('div').withConfig({
  displayName: "DragAndDrop__StyledDiv",
  componentId: "sc-1dr96yf-0"
})(["position:fixed;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,0.33);display:flex;justify-content:center;align-items:center;animation:fadein 0.5s;z-index:10;backdrop-filter:blur(4px);@keyframes fadein{from{opacity:0;}to{opacity:1;}}"]);
var StyledText = styled('div').withConfig({
  displayName: "DragAndDrop__StyledText",
  componentId: "sc-1dr96yf-1"
})(["font-size:36px;text-shadow:0 0 16px rgba(0,0,0,0.4);color:#fff;letter-spacing:1px;background-color:rgba(0,0,0,0.4);border-radius:4px;padding:36px;"]);

// NOTE: Might be better ways to handle dragCounter in state?
var dragCounter = 0;
var DragAndDrop = function DragAndDrop(props) {
  // Define props
  var handleFileDrop = props.handleFileDrop;

  // Define state
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];

  // Use effects
  useEffect(function () {
    window.document.body.addEventListener('dragenter', handleDragEnter);
    window.document.body.addEventListener('dragover', handleDragOver, false);
    window.document.body.addEventListener('dragleave', handleDragLeave);
    window.document.body.addEventListener('drop', handleDrop, false);
    return function () {
      window.document.body.removeEventListener('dragenter', handleDragEnter);
      window.document.body.removeEventListener('dragover', handleDragOver, false);
      window.document.body.removeEventListener('dragleave', handleDragLeave);
      window.document.body.removeEventListener('drop', handleDrop, false);
    };
  }, []);

  // Event handlers
  var handleDragEnter = function handleDragEnter(e) {
    e.preventDefault();
    e.stopPropagation();
    dragCounter++;
    setIsDragging(true);
  };
  var handleDragOver = function handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
  };
  var handleDragLeave = function handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    dragCounter--;
    if (dragCounter === 0) {
      setIsDragging(false);
    }
  };
  var handleDrop = function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    dragCounter = 0;
    setIsDragging(false);
    handleFileDrop(e.dataTransfer.files);
  };
  return isDragging ? /*#__PURE__*/React.createElement(StyledDiv, null, /*#__PURE__*/React.createElement(StyledText, null, "Drop the file anywhere")) : null;
};
export default DragAndDrop;